// Shared only by order saving and its edit-session lease. No global fetch hook.
let clientId = null;
let pending = 0;
export function setReleaseClientId(value) { clientId = value; }
export function releaseRequestsPending() { return pending; }
export async function releaseClientFetch(input, options = {}) {
  const headers = new Headers(options.headers);
  if (clientId) headers.set('X-KS-Release-Client', clientId);
  pending++;
  try { return await fetch(input, { ...options, headers }); }
  finally { pending--; }
}
